import React, { forwardRef } from 'react';

import { ModalContainer } from 'components/core';
import { LoginModalContent } from './login-modal-content';

export const LoginModalContainer = forwardRef(({ onClose, containerProps }, ref) => (
  <ModalContainer ref={ref} padding={0} width={420} {...containerProps}>
    <LoginModalContent onClose={onClose} />
  </ModalContainer>
));
